import isEmpty from 'lodash/isEmpty';

// https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-update_option
export default function payoutCheckingPrepareDataForRequest(formData) {
  const result = {
    updateOption: {
      type: formData.type,
      firstName: formData.firstName,
      lastName: formData.lastName,
    },
  };

  if (isEmpty(formData.paymentOption)) {
    // creating new

    switch (formData.type) {
      case 'EFT':
        result.updateOption.accountType = formData.accountType;
        result.updateOption.accountNumber = formData.accountNumber;
        result.updateOption.institutionNumber = formData.institutionNumber;
        result.updateOption.branchNumber = formData.branchNumber;
        result.addOption = result.updateOption;
        delete result.updateOption;
        break;


      default:
        console.warn('uknown type of account');
        return null;
    }
  }

  return result;
  // {
  //   "addOption": {
  //     "type": "EFT",
  //     "accountType": "checking",
  //     "accountNumber": "1234567",
  //     "institutionNumber": "123",
  //     "branchNumber": "12345",
  //     "firstName": "Tom",
  //     "lastName": "Jerry"
  //   }
  // }
}
